


















export default

	props:
		name: String
		label: String
		value: String

